import React from 'react';
import ReactDOM from 'react-dom/client';
import './polyfills';
import { installerTenantFetch } from './tenantFetch';
import { installerGardeMolette } from './utils/gardeMolette';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Avant tout rendu : chaque appel vers /api porte desormais son ecole, meme
// depuis les hooks qui utilisent `fetch` sans passer par services/api.js.
installerTenantFetch();

// Avant tout rendu : la molette ne change plus un montant saisi (voir le
// fichier, constat du 12/10/2026 sur les réductions d'élèves).
installerGardeMolette();

// Désactiver les logs en production

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// KLASYS est une application connectee : un ancien cache PWA peut servir un
// bundle obsolete sur certaines tablettes Android et laisser l'ecran blanc.
serviceWorkerRegistration.unregister();

// Mesure des performances (optionnel)
reportWebVitals();
